import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export const patientService = {
  getPatients: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.gender) queryParams.append('gender', params.gender);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

    const endpoint = `${API_CONFIG.endpoints.patients}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await api.get(endpoint);
    return response.data;
  },

  getPatientById: async (id) => {
    const response = await api.get(`${API_CONFIG.endpoints.patients}/${id}`);
    return response.data;
  },

  createPatient: async (patientData) => {
    const response = await api.post(API_CONFIG.endpoints.patients, patientData);
    return response.data;
  },

  updatePatient: async (id, patientData) => {
    const response = await api.patch(`${API_CONFIG.endpoints.patients}/${id}`, patientData);
    return response.data;
  },

  deletePatient: async (id) => {
    const response = await api.delete(`${API_CONFIG.endpoints.patients}/${id}`);
    return response.data;
  },

  getPatientStats: async () => {
    const response = await api.get(`${API_CONFIG.endpoints.patients}/stats`);
    return response.data;
  },

  uploadProfilePicture: async (patientId, file) => {
    const formData = new FormData();
    formData.append('profilePicture', file);
    const response = await api.post(
      `${API_CONFIG.endpoints.patients}/${patientId}/profile-picture`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data;
  },
};

export default patientService;
